import { createStore, combineReducers, applyMiddleware } from 'redux'
import { persistStore, persistReducer } from 'redux-persist'
import miusuario from '../redux/reducers/miusuario'
import pais from '../redux/reducers/pais'
import idioma from '../redux/reducers/idioma'
import modo from '../redux/reducers/modo'
import esquema_actual from '../redux/reducers/esquema'
import esquema_tablas from '../redux/reducers/esquema_tablas'
import storage from 'redux-persist/lib/storage' // defaults to localStorage for web
import interfaz from '../redux/reducers/interfaz'
import lista_precios from '../redux/reducers/lista_precios'
import bodegas from '../redux/reducers/lista_bodegas'
import sitio from '../redux/reducers/tienda'
import user from '../redux/reducers/user'
import valueForShipping from '../redux/reducers/shipping_free'
import direcciones from '../redux/reducers/direcciones'
import cart from '../redux/reducers/cart'

const thunkMiddleware = require('redux-thunk').default

const rootReducer = combineReducers({
    value_for_free_shipping: valueForShipping,
    miusuario,
    cart,
    interfaz,
    pais,
    esquema_tablas,
    idioma,
    modo,
    esquema_actual,
    lista_precios,
    bodegas,
    sitio,
    user,
    direcciones
})

const persistConfig = {
  key: 'root',
  storage,
}
 
const persistedReducer = persistReducer(persistConfig, rootReducer)
 
export default () => {
  let store = createStore(persistedReducer, applyMiddleware(thunkMiddleware))
  let persistor = persistStore(store)
  return { store, persistor }
}